
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import xheader from '../components/xheader.vue';
import xsilde from '../components/xsilde.vue';
import sheader from '../components/search/sheader.vue';
import xplay from "../components/xplay.vue"
export default {
components: {
xheader,
Tab,
TabItem,
xsilde,
sheader,
xplay
}
}



// WEBPACK FOOTER //
// ./src/views/search.vue